import * as React from 'react';

import { cn } from '@/lib/utils';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
	({ className, type, ...props }, ref) => {
		return (
		<input
			type={type}
			className={cn(
				'flex h-10 w-full rounded-md field-surface field-border px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground transition-colors focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 appearance-none [&:-webkit-autofill]:![box-shadow:0_0_0_1000px_hsl(0_0%_100%/0.03)_inset] [&:-webkit-autofill]:[-webkit-text-fill-color:hsl(var(--foreground))] [&:-webkit-autofill]:[caret-color:hsl(var(--foreground))] [&:-webkit-autofill]:!border-white/[0.08] [&:-webkit-autofill:hover]:![box-shadow:0_0_0_1000px_hsl(0_0%_100%/0.03)_inset] [&:-webkit-autofill:hover]:!border-white/20 [&:-webkit-autofill:focus]:![box-shadow:0_0_0_1000px_hsl(0_0%_100%/0.03)_inset] [&:-webkit-autofill:focus]:!border-white/30 [&:-webkit-autofill]:transition-colors',
				className
			)}
			ref={ref}
			{...props}
		/>
		);
	}
);
Input.displayName = 'Input';

export { Input };
